/* istanbul ignore file */
/**
 * This function will be ran as a deferred script that will potentially load the onetrust scripts. It will only load
 * the script if it hasn't been loaded already by GTM.
 *
 * This is needed because generally speaking, GTM is being used to load onetrust on ALL pages (including wordpress),
 * and instead of trying to dismantle that implementation, we are opting to just load the script when it's needed, to
 * avoid loading twice.
 */
const loadOneTrustScriptIfNeeded = function () {
  const WAIT_TO_SEE_IF_GTM_LOADS_IT_MS = 2000

  setTimeout(() => {
    const alreadyLoaded =
      document?.querySelectorAll('[id="onetrust-pc-sdk"]')?.length > 0

    const message = alreadyLoaded
      ? '%c OneTrust previously loaded'
      : '%c Loading OneTrust'
    console.info(message, 'background: #036eb5; color: #fff; padding: 3px 6px;') // eslint-disable-line

    if (!alreadyLoaded) {
      const coreCall = document.createElement('script')
      coreCall.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
      coreCall.defer = true
      coreCall.crossOrigin = 'anonymous'
      coreCall.setAttribute(
        'data-domain-script',
        '1f2fe5b4-03e4-4b3b-8665-632238e0e3de'
      )
      document.body.appendChild(coreCall)
    }
  }, WAIT_TO_SEE_IF_GTM_LOADS_IT_MS)
}

export const getOneTrustScript = () =>
  `(${loadOneTrustScriptIfNeeded.toString()}())`
